export default __webpack_public_path__ + "static/CH_Assembly-b59718f2505adc86753effad6ed72afb.svg";